import API_URLS from '../links';

export const getPayment = (creds, id) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.GET_PAYMENT_HISTORY + '/' + id, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          access_token: creds.access_token
        }
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const addPayment = (creds, values) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.ADD_PAYMENT, {
        method: 'POST',
        headers: {
          access_token: creds.access_token,
          'content-type': 'application/json'
        },
        body: JSON.stringify(values)
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const deletePayment = (creds, id) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.DELETE_PAYMENT + `/${id}`, {
        method: 'DELETE',
        headers: {
          access_token: creds.access_token
        }
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const updatePaymentHistory = (creds, values, id) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.UPDATE_PAYMENT + `/${id}`, {
        method: 'PUT',
        headers: {
          access_token: creds.access_token,
          'content-type': 'application/json'
        },
        body: JSON.stringify(values)
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};
